import React from 'react'
import { useHistory } from "react-router-dom";
import { ReactComponent as OptionsIcon } from '../../../img/ic_opciones.svg'
import circle from '../../../assets/img/circulogris.png';
import './ListSocial.css'
import ModalMenu from '../../ModalMenu';
import { Translate } from '../../../language';
import CardList from '../../../utils/components/CardList/CardList';
import localStorage from '../../../utils/hooks/useLocalStorage';

const ListSocial = ({
    iduser,
    listSocial = [1, 2, 2, 4],
    listName = 'amigos',
    deleteSocial = ()=>{}
}) => {
    const history = useHistory()
    if (listSocial.length > 0)
        return (
            <div className="content-list-social scroll-menu">
                {listSocial.map(([id, { user, social }]) => {
                    return user.type ==="user" &&
                        <CardList
                            key={id}
                            options={[
                                (
                                    iduser === localStorage().getItem("idUser")) && {
                                    text: Translate('delete', 'es'), onClick: (e) => {
                                        deleteSocial(id)
                                        e.preventDefault(); e.stopPropagation();
                                    }

                                }
                            ]}
                            onClick={(e) => {
                                history.push(`/Profile/${id}`)
                                e.preventDefault(); e.stopPropagation();
                            }}
                            picture={user?.picture?.url ? user.picture.url.small : user.picture}

                            textOne={user.name.split(' ')[0]}
                            textTwo={user.lastname.split(' ')[0]}

                        />
                }
                )}
            </div>
        )
    else
        return (
            <div>
                {'Aun no tienes ' + listName}
            </div>
        )
}

export default ListSocial
